import { useEffect, useState } from "react"
import { useSnapshot } from "valtio"
import { AgSelect } from "../components/AgComponents"
import { EntityV2Store, bookingsStore, configStore, entityStore, loginStore } from "../state/CommonState"
import Utils from "../util/Utils"
import Otheraction from "./act-otheraction"
import TaskContainer from "./task-container"
import TaskDatetime from "./task-datetime"
import Tasklistsmall from "./task-list-small"
import { taskStore } from "./task-store"
import Taskapi, { Task } from "./tasks-api"
import { getAction, getfilenames, getActionList, getActionListNames, getActionsForShipmentType, getPayload, getTriggercomp } from "./tasks-static-data"
import BranchApi from "../state/branch-api"
import MonApi from "../state/mongo-api"

export default function TaskTrigger(props) {
    useSnapshot(taskStore)
    useSnapshot(bookingsStore)
    useSnapshot(entityStore)
    useSnapshot(EntityV2Store)
    const [branch,setBranch] = useState('')
    const [relationManager,setRelationManager] = useState('')
    const [customerService,setCustomerService] = useState('')
    const [shippingBillNumber,setShippingBillNumber] = useState('')
    const [oldActions, setOldActions] = useState([])
    const [otherActions, setOtherActions] = useState([])
    const [currentActionlastdate, setCurrentActionlastdate] = useState("")
    const [openPending,setOpenPending] = useState(true)
    const [entities,setEntities] = useState([])
    let active = 'none'
    if (taskStore.triggerActionVisible) active = 'block'
    let b = bookingsStore.current
    let task = taskStore.current
    let action = getAction(taskStore.current.actionName)
    let Comp = action?.triggercomp
    function setaction(name){
        let current = oldActions.filter(e => e.actionName === name)
        if(current.length>0){
            if(current[current.length-1]['actionName']!="Update Cost"){
                let date = Utils.formatToDateTime(current[current.length-1]['completedOn'])
                if(current[current.length-1]['actionName']=="Carrier Release Order"){
                    taskStore.current.actionName = ""
                    configStore.setModalMessage("This action has been previously completed on: "+date)
                }else{
                    configStore.setModalMyacticecompleted("This action has been previously completed on: "+date)
                }
                setCurrentActionlastdate(date)
            }else{
                taskStore.current = current[0]
                taskStore.current.dueDate = ""
                taskStore.current.dueTime = ""
                setCurrentActionlastdate("")
            }
        }else{
            setCurrentActionlastdate("")
        }
        
    }
    function enterpriseActionCheck(name){
        let filesUploaded = false
       if(name=='Carrier Release Order'){
          if(b?.carrierReleaseOrderList?.length > 0){
            filesUploaded = true
          }
       }else if(name=='Upload Measurement Slip'){
          if(b?.measurementSlipList?.length > 0){
            filesUploaded = true
          }
       }else if(name == 'BL Draft Approval'){
          if(b?.blDraftList?.length > 0){
            filesUploaded = true
          }
       }else if(name == 'DO Release(Ocean)'){
          if(b?.deliveryOrderList?.length > 0){
            filesUploaded = true
          }
       }else if(name == 'AWB Draft Approval'){
          if(b?.awbDraftList?.length > 0){
            filesUploaded = true
          }
       }else if(name == 'Invoice Acceptance'){
           if(b?.freightInvoiceList?.length>0||b?.customsTaxesDutiesList?.length>0){
              filesUploaded = true
           }
       }else if(name == 'Commercial Invoice & Packing List Pending'){
           if(b?.commercialInvoicePackingList?.length > 0){
            filesUploaded = true
          }
       }else if(name == 'POD Procurement'){
           if(b?.podList?.length >0){
            filesUploaded = true
           }
       }

    //    if(filesUploaded){
    //         configStore.setModalMyacticecompleted("Document is already available. Do you still want to trigger the action?")
    //    }
    }
    const showdest = (key) =>{
        console.log(key)
        if(b?.contract[key]!=undefined && b?.contract[key].length>0){
            return <>
            <hr style={{margin:"0px"}}/>
            {b?.contract[key]}
            </>
        }
    }
    useEffect(() => {
        let f = async () => {
            let ret = await Taskapi.getTasklist4Booking(b._id)
            // if(ret.status === 400){
            //     return configStore.setModalMessage(ret.message)
            // }else {
                let old = ret?.filter(e => e.status === 'COMPLETED')
                if(JSON.stringify(old)!=JSON.stringify(oldActions)){
                    setOldActions(old)
                }
                ret = ret?.filter(e => e.status === 'PENDING')
                console.log('RESULT OF BOOKINGS ACTIONS=', ret)
                if(JSON.stringify(ret)!=JSON.stringify(otherActions)){
                    setOtherActions(ret)
                }
            // }
        }
        f()
        let getBranchName = async (branchId)=>{
                    const data = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/stakeholder/list/branches/${task.entityId}`)            
                    const b = data.results.filter((x,i) => x.branchId === branchId)
                    setBranch(b[0].state)
                }
                getBranchName(task.branchId)
        
                let getRMName = async ()=>{
                const entityList = EntityV2Store.list.filter((e) => e.entityId === task.entityId)
                if(entityList[0]?.customer?.crossBorder?.relationshipManager){
                const data = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${entityList[0].customer?.crossBorder?.relationshipManager}`)  
                setRelationManager(data?.firstName+" "+data?.lastName+"("+data.email+','+data?.phone+")")
                }
            }
                getRMName()
        
                let getCSName = async ()=>{
                const entityList = EntityV2Store.list.filter((e) => e.entityId === task.entityId)
                if(entityList[0]?.customer?.crossBorder?.customerService){
                const data = await MonApi.aget(`${process.env.REACT_APP_API_SERVER}/api/v1/aguser/${entityList[0].customer?.crossBorder?.customerService}`)  
                setCustomerService(data?.firstName+" "+data?.lastName+"("+data.email+','+data?.phone+")")
                } 
            }
                getCSName()

            let getShippingBillNumber = async ()=>{
              const data = await MonApi.find('Bookingdsr', {_id:task.bookingNum},{})
              const obj = data[0]
              setShippingBillNumber(Object.keys(obj)
                ?.filter(key => key.startsWith("exportClearance")) 
                ?.flatMap(key => obj[key]
                        ?.filter(item => item.label === "Shipping Bill Number" && item.value != '') 
                        ?.map(item => item.value))  
                .join(", "))
            }
            getShippingBillNumber()
    }, [])
    useEffect(()=>{
        console.log("+++++++++++++++++++++++++91",(taskStore.current!=undefined && taskStore.current.actionName!=undefined && taskStore.current.actionName.trim().length != 0 && taskStore.current.actionName!= taskStore.name))
        if(taskStore.current!=undefined && taskStore.current.actionName!=undefined && taskStore.current.actionName.trim().length != 0 && taskStore.current.actionName!= taskStore.name){
            taskStore.name = taskStore.current.actionName
            taskStore.oldtask = JSON.parse(JSON.stringify(taskStore.current))
        }
        if(taskStore.name.trim().length>0 && taskStore.name==taskStore.current.actionName){
            taskStore.oldtask = JSON.parse(JSON.stringify(taskStore.current))
        }
    },[JSON.stringify(taskStore.current)])
    if (taskStore.myActionVisible) return <TaskContainer />
    return (
        <div  style={{ display: active, width: '100%' }}>
            <div>
                <div style={{ height: '70vh' }}>
                    <div className="columns">
                        <div className="column is-7">
                            <h5 className="title is-4" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold' }}>
                                Action
                            </h5>
                            {
                                (currentActionlastdate.length>0?
                                <>
                                <p className="title is-6" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold' }}>
                                This action has been previously completed on: {currentActionlastdate}
                            </p>
                                </>:<></>)
                            }
                            <div className="box">
                            <tr>
                                <td><strong>Booking ID</strong></td>
                                <td style={{ width: '20px' }}></td>
                                <td>{b?._id}</td>
                                </tr>
                            { !loginStore.isClient() ?
                            <>
                                  <tr>
                                    <td><strong>Customer Name</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{EntityV2Store.getEntityById(task.entityId).map(item => item.split('-')[0].trim())[0]}</td>
                                </tr>
                                <tr>
                                    <td><strong>Branch Name</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{branch}</td>
                                </tr>

                                {relationManager&&<tr>
                                    <td><strong>Relationship Manager</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{relationManager}</td>
                                </tr>}
                                {customerService&&<tr>
                                    <td><strong>Customer Service</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{customerService}</td>
                                </tr>}
                                {shippingBillNumber && <tr>
                                    <td><strong>Shipping Bill Number</strong></td>
                                    <td style={{ width: '20px' }}></td>
                                    <td>{shippingBillNumber}</td>
                                </tr>
                                }
                                </>
                                :<></>
                                }
                                
                            
                            <tr>
                                <td>{b?.contract?.origin}</td>
                                <td style={{ fontSize: '1.2rem', fontWeight: 'bold' }}> &#8594; </td>
                                <td>{b?.contract?.destination}
                                {showdest("destination2")}
                                        {showdest("destination3")}
                                        {showdest("destination4")}
                                        {showdest("destination5")}
                                </td>
                            </tr>
                            <tr>
                                <td>{b?.contract?.shipmentType}</td>
                                <td style={{ width: '20px' }}></td>
                                <td>{b?.contract?.shipmentScope}</td>
                            </tr>
                            </div>
                        </div>
                        <div className="column is-5" style={{ fontSize: '0.80rem' }}>
                            <button style={{ float: 'right' }} className="button is-small islink"
                                onClick={async (e) => {
                                    taskStore.triggerActionVisible = false
                                }}>
                                <span className="icon ">
                                    <i className="fas fa-xmark"></i>
                                </span>
                            </button>
                            <div>
                            <button className="button is-link"  style={{backgroundColor:process.env.REACT_APP_ENTERPRISE_COLOUR}} onClick={()=> {
    setOpenPending(!openPending)
}} >
                                Pendings
                            </button>
                            </div>
                            <hr />
                            {
                            (openPending?<Tasklistsmall actionList={otherActions} />: <></>)
                        }
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-12">
                            <p></p><hr /><p></p>
                            {
                                (bookingsStore.current.status!="CANCELLED" && bookingsStore.current.status!="Cancellation Requested")?<p>
                                <AgSelect label='Select an Action to trigger' record={taskStore.current} 
                                    name='actionName'
                                    dataList={getActionsForShipmentType(b, EntityV2Store.EntityRec, otherActions,oldActions)}
                                    callback={(val) => {
                                        if(getPayload(taskStore.current.actionName)!==undefined){
                                        Object.assign(taskStore.current, JSON.parse(JSON.stringify(getPayload(taskStore.current.actionName))))
                                        }
                                        if(taskStore.current.actionName === 'Invoice Acceptance'||taskStore.current.actionName === 'Entry Summary Approval'){
                                            delete taskStore.current.currency
                                            taskStore.currencyData = JSON.parse(JSON.stringify([{label: "",currencyType: "",remarks: "",netAmount: 0,gstAmount: 0,totalAmount: 0}]))
                                        } 
                                        if(taskStore.current && taskStore.current.files!=undefined){
                                            for (let i = 0; i < taskStore.current.files.length; i++) {
                                                taskStore.current.files[i]['filename'] = ""
                                                taskStore.current.files[i]['invoiceNo'] = ""
                                                taskStore.current.files[i]['invoiceDate'] = ""
                                                taskStore.current.files[i]['approved'] = ""
                                                taskStore.current.files[i]['rejectReason'] = ""
                                            }
                                        }
                                        if(taskStore.current.actionName === 'Other Actions (FCL)'||taskStore.current.actionName === 'Other Actions (LCL)'){
                                            if(taskStore.current.origin.toLowerCase().includes("india")){
                                                taskStore.current.files = taskStore.current.files.filter(e=>e.label !== 'Bill-of-Entry')
                                            }
                                            if(taskStore.current.destination.toLowerCase().includes("india")){
                                                taskStore.current.files = taskStore.current.files.filter(e=>e.label !== 'Shipping Bill')
                                            }
                                            if(!taskStore.current.destination.toLowerCase().includes("india") && !taskStore.current.origin.toLowerCase().includes("india")){
                                                taskStore.current.files = taskStore.current.files.filter(e=>e.label !== 'Shipping Bill'&&e.label !== 'Bill-of-Entry')
                                            }
                                        }
                                        if(taskStore.current.actionName!='DO Release (Air)'){
                                            taskStore.current.original_file = getfilenames(taskStore.current.files)
                                        }
                                        if(taskStore.current.actionName=='Delivery Appointment' ){
                                            if(b && b.contract && b.contract['multidest']!=undefined){
                                                let k = []
                                                for (let i = 0; i < b.contract['multidest'].length; i++) {
                                                    k.push({
                                                        address: '',
                                                        pinCode: '',
                                                        contactdetails:[{
                                                            contactName: '',
                                                            contactNumber: '',
                                                            contactEmail: ''
                                                        }],
                                                        pickupDate: '',
                                                        pickupTimeFrom: '',
                                                        pickupTimeTo: ''
                                                    })
                                                }
                                                taskStore.current.details = k
                                            }
                                        }
                                        if((taskStore.current.actionName=='Pick-up Appointment' || taskStore.current.actionName=='Delivery Appointment' ) && b?.contract?.shipmentType.toLowerCase().includes("fcl")){
                                            let c = []
                                            for (let i = 0; i < b.contract.containerList.length; i++) {
                                                for (let j = 0; j < Number(b.contract.containerList[i]['numContainers']); j++) {
                                                    c.push({
                                                        container:(j+1)+". "+b.contract.containerList[i].containerType,
                                                        pickupDate: '',
                                                        pickupTimeFrom: '',
                                                        pickupTimeTo: ''
                                                    })
                                                }
                                                
                                                
                                            }
                                            taskStore.current.containersList = c

                                        }
                                        setaction(taskStore.current.actionName)
                                        if(EntityV2Store?.EntityRec?.customer?.crossBorder?.salesVertical != 'MSME'){
                                           enterpriseActionCheck(taskStore.current.actionName)
                                        }
                                        
                                    }} />
                            </p>:""
                            }
                            <p>
                                {
                                    (Comp) ? <Comp action={action} /> : <></>
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}